export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const ENDPOINTS = {
    LOGIN: "/wp-json/login-api/v1/consume",
    SEARCH_JOBS: "/wp-json/anz-api/v1/filter/search",
};
